/**
 * GlobalSocketListeners — componente null-render que monta listeners globais
 * de socket.io. Deve ser montado UMA ÚNICA VEZ no root da app, dentro de
 * AuthProvider + SocketProvider.
 *
 * Por que um componente dedicado (em vez de chamar os hooks direto no
 * AuthContext/AppContext): evita acoplar providers de estado a lógica de
 * side-effects de socket. O componente pode ser removido/mockado em testes
 * sem afetar a árvore de providers.
 *
 * Não renderiza nada (retorna null). Adicione novos listeners globais aqui.
 */

import { useConversationListSocket } from '@/shared/hooks/useConversationListSocket';
import { useDeviceRemovedSocket } from '@/shared/hooks/useDeviceRemovedSocket';
import { useGlobalMessageSocket } from '@/shared/hooks/useGlobalMessageSocket';
import { useLeadCaptureSocket } from '@/shared/hooks/useLeadCaptureSocket';
import { useNotificationSoundSocket } from '@/shared/hooks/useNotificationSoundSocket';
import { useSocketReconnectResync } from '@/shared/hooks/useSocketReconnectResync';
import { useUnreadCountSocket } from '@/shared/hooks/useUnreadCountSocket';
import { useCreditPaymentSocket } from '@/modules/billing/hooks/useCreditPaymentSocket';

export const GlobalSocketListeners = (): null => {
  useGlobalMessageSocket();
  useNotificationSoundSocket();
  useConversationListSocket();
  // Contadores não-lidos (chat+email) e confirmação de pagamento PIX — eram
  // montados no Header; movidos p/ cá (NUNCA #38) pra sobreviverem quando o
  // Header for substituído pela sidebar (F3). Modais de billing mantêm instância
  // própria de useCreditPaymentSocket para o estado `confirmedPayment`.
  useUnreadCountSocket();
  useCreditPaymentSocket();
  // Logout remoto quando ESTE device é removido em "Dispositivos conectados"
  useDeviceRemovedSocket();
  // Captura por QR: sessão avança na modal/dashboard em tempo real (Parte 2)
  useLeadCaptureSocket();
  // Queda de rede: os eventos do intervalo se perdem — refaz conversa aberta,
  // lista e contadores ao reconectar (incidente 2026-08-29)
  useSocketReconnectResync();
  // futuros listeners globais podem ser adicionados aqui
  return null;
};
